export default __webpack_public_path__ + "static/media/3.35be7858.jpg";